export default __webpack_public_path__ + "static/media/ic_checked.86059d06.svg";